<ll-titulo>Instrumentos Predefinidos</ll-titulo>
<ll-toolnavbar>
    <instrumento-predefinidos-toolnavbar [displayButtons]="'search new'"></instrumento-predefinidos-toolnavbar>
</ll-toolnavbar>

<instrumento-predefinidos-buscador></instrumento-predefinidos-buscador>
<instrumento-predefinidos listRoute="instrumento_predefinidos"></instrumento-predefinidos>
